<template lang='pug'>
.body(@click='panelClick')
    .left
        .name {{ info.name }}
        .desc {{ info.desc }}
        .icon-box
            img(
                src='@/assets/imgs/download-b.png',
                v-if='!isVideo',
                @click.stop='downloadItem'
            )
            img(
                src='@/assets/imgs/star.png',
                @click.stop='_book',
                v-if='bookId'
            )
            img(src='@/assets/imgs/unstar.png', @click.stop='_book', v-else)
    .right(v-if='lazy')
        template(v-if='isVideo')
            img.banner.video(v-if='isVideo', v-lazy='info.link', data-poster)
            img.play(src='@/assets/imgs/play.png')
        img.banner(v-lazy='info.banner', v-else)
    .right(v-else)
        template(v-if='isVideo')
            img.banner.video(v-if='info.banner', v-src='info.banner')
            img.banner.video(v-else, v-src='info.link' data-poster)
            img.play(src='@/assets/imgs/play.png')
        img.banner(v-src='info.banner', v-else)
</template>

<script>
import book from '@/views/mixin/book'
export default {
    mixins: [book],
    props: {
        info: {
            type: Object,
            default() {
                return {}
            }
        },
        lazy: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },
    computed: {
        isVideo() {
            return this.info.type === 'video'
        }
    },
    methods: {
        panelClick() {
            // this.$router.push({ name: this.info.type + 'Viewer', params: { id: this.info.id } })
            this.$router.push({ name: this.info.type + 'Viewer', params: { rId: this.info.rId } })
        },
        downloadItem() {
            window.location.href = this.info.link
        }
    }
}
</script>

<style scoped lang='less'>
.body {
    display: flex;
    justify-content: space-between;
    .left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 0.3rem;
    }
    .right {
        position: relative;
        margin-left: 0.3rem;
        .banner {
            display: block;
            width: 4rem;
            height: 5.6rem;
            object-fit: cover;
        }
        .video {
            filter: brightness(0.5);
            width: 6rem;
        }
        .play {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1.8rem;
            object-fit: contain;
        }
    }
    .icon-box {
        display: flex;
        margin-top: 0.4rem;
        > img {
            width: 0.85rem;
            height: 0.85rem;
            object-fit: contain;
            margin-right: 0.6rem;
            cursor: pointer;
        }
    }
}
</style>